import { createTheme } from '@mui/material/styles';
import { Components } from '@mui/material/styles/components';

const theme = createTheme();

export const CardContentComponent: Components = {
  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: theme.spacing(1, 2),
      },
    },
  },
};
